import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { createSelector } from 'reselect';
import * as RequestStates from 'ecosystem-marketplace-core/constants/RequestState';
import { getCollections } from '../../clients/ecosystemClient';
export const fetchCollections = createAsyncThunk('collections/fetchAll', appContext => {
  return getCollections(appContext).then(response => response.collections);
});
const initialState = {
  list: [],
  requestState: RequestStates.UNINITIALIZED
};
export const collectionsSlice = createSlice({
  name: 'collections',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCollections.pending, state => {
      state.requestState = RequestStates.PENDING;
    }).addCase(fetchCollections.fulfilled, (state, action) => {
      state.requestState = RequestStates.SUCCEEDED;
      state.list = [...action.payload].reverse();
    }).addCase(fetchCollections.rejected, state => {
      state.requestState = RequestStates.FAILED;
    });
  }
});
export default collectionsSlice.reducer;
export const selectCollections = state => state.collections.list;
export const selectCollectionsRequestState = state => state.collections.requestState;
export const createSelectCollectionSlugs = previewCollectionId => createSelector([selectCollections], collections => collections.reduce((final, collection) => {
  const collectionListing = collection.id === previewCollectionId ? collection.draftListing : collection.publishedListing;

  if (collectionListing) {
    final.push(collectionListing.slug);
  }

  return final;
}, []));
export const selectCollectionSlugs = createSelectCollectionSlugs();
export const createSelectDisplayedCollections = previewCollectionId => createSelector([selectCollections], collections => collections.reduce((final, collection) => {
  const collectionListing = collection.id === previewCollectionId ? collection.draftListing : collection.publishedListing;

  if (collectionListing && collectionListing.displayed) {
    final.push(collection);
  }

  return final;
}, []));
export const selectDisplayedCollections = createSelectDisplayedCollections();
export const selectCollectionById = createSelector([selectCollections, (__state, id) => id], (collections, id) => collections.find(collection => collection.id === id));
export const selectCollectionBySlug = createSelector([selectCollections, (__state, slug) => slug], (collections, slug) => collections.find(collection => collection.publishedListing && collection.publishedListing.slug === slug));